import React, { useEffect, useRef, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as OrderAction from 'actions/order-action';
import * as OTROrderAction from 'actions/otr/otr-order-action';
import * as DriverAction from 'actions/driver-action';
import * as BillPayAction from 'actions/billpay-action';
import {
  Box,
  Button,
  ButtonGroup,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  Fade,
  Typography,
  IconButton,
  TextField,
  Menu,
  MenuItem,
  Tabs,
  Tab,
} from '@mui/material';
import Page from 'components/Page';
import PageHeader from 'global/PageHeader';
import Searchbar from 'global/Searchbar';
import Notificationbar from 'global/Notificationbar';
import CustomSelectField from 'components/Select-Field/custom-select';
import { CancelOutlined, CheckCircleOutlined, CheckCircleOutlineOutlined, CloseOutlined, InfoOutlined, MenuOutlined, WarningOutlined } from '@mui/icons-material';
import CTTabs from 'components/CTTabs';
import DataDialog from 'components/dialogs/DataDialog';
import Remittance from './remittance';
import FilesModal from 'components/files-modal';
import { getRemittanceInformation } from 'services/remittance-service';
import { getFilesByOrderId } from 'services/order-service';
import NotificationDialog from 'components/dialogs/NotificationDialog';

import BillPayTable from './billpay-table';
import LegCharge from 'containers/driver-charges/driver-charge';
import * as PaymentService from 'services/payment-service';
import * as OTRPaymentService from 'services/otr/otr-payment-service';
import * as LegService from 'services/leg-service';
import * as OTRLegService from 'services/otr/otr-leg-service';
import { AggregateLegCharges } from 'utils/calculations';
import OrderLeg from 'containers/Dispatch/Dispatch-OrderLeg/order-leg';
import InputField from 'components/Input-Field/input-field';
import { DateRangePicker } from 'rsuite';
import ChartContainer from 'components/Charts/chart-container';
import { tokens } from 'theme/tokens';
import PieChart from 'components/Charts/piechart';
import { formatCurrency } from 'utils/formatter';
import BarChart from 'components/Charts/barchart';
import ContentDrawer from 'components/ContentDrawer';
import LoadDetail from 'containers/Dispatch/views/load-detail';
import FTIcons from 'assets/icons/FTIcons';
import { useTheme } from '@mui/material/styles';

const BILL_STATUS_TABS = ['UNPAID', 'PAID_PARTIAL', 'PAID'];
const PIE_CHART_COLORS = {
  'PAID': '#1F8E3D',
  'PAID_PARTIAL': '#1F8E3D',
  'UNPAID': '#D92D20'
};
const SEARCH_FIELDS = [
  { 'name': 'driver', 'label': 'driver', 'type': 'datalist' },
  { 'name': 'date-range', label: 'Select Date', type: 'date-range' },
  { 'name': 'legId', 'label': 'LegId', 'type': 'text' },
  { 'name': 'containerNumber', 'label': 'Container Num.', 'type': 'text' },
  { 'name': 'paymentNumber', 'label': 'Payment Number', 'type': 'text' },
  { 'name': 'reportDate', 'label': 'ReportDate', 'type': 'date' }
];

const BillManager = (props) => {
  const INITIAL_PAGE = 0;
  /* Theme */
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const fileModalChildRef = useRef(null);
  const dispatch = useDispatch();
  const { tenantBusinessModel } = props.tenant;
  const mode = tenantBusinessModel === 'ALL' ? 'INTERMODAL' : tenantBusinessModel; // In case of ALL > we can default to Intermodal

  /* State Variables */
  const [tabIndex, setTabIndex] = useState(0);
  const [billStatus, setBillStatus] = useState('UNPAID');
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedBill, setSelectedBill] = useState(null); // Selected Bill object using menu option.
  const [transportationMode, setTransportationMode] = useState(mode);

  const [anchorMainMenu, setAnchorMainMenu] = useState(null);
  /* DIALOGS */
  const [isLegChargeDialogOpen, setLegChargeDialog] = useState(false);
  const [isDriverRateDialogOpen, setDriverRateDialog] = useState(false);
  const [isOrderDetailDialogOpen, setOrderDetailDialog] = useState(false);
  const [isLegDetailDialogOpen, setLegDetailDialog] = useState(false);
  const [isRemittancePaymentDialogOpen, setRemittancePaymentDialog] = useState(false);
  const [isProcessPayment, setProcessPayment] = useState(false);  // Process Payment will have both check form and check table.
  const [isNotificationDialogOpen, setNotificationDialog] = useState(false);
  const [isFileUploadDialogOpen, setFileUploadDialog] = useState(false);
  const [isAdvanceSearchDialogOpen, setAdvanceSearchDialog] = useState(false);

  const [isSearchEnabled, setSearchEnable] = useState(false);
  const [searchParameters, setSearchParameters] = useState({});

  const [legCharges, setLegCharges] = useState([]);
  const [legChargeFormAction, setLegChargeFormAction] = useState('Save');

  const [remittanceData, setRemittanceData] = useState([]);
  const [page, setPage] = useState(INITIAL_PAGE);
  const [pageSize, setPageSize] = useState(25);
  // The useRef Hook allows you to persist data between renders
  const prevPageRef = useRef(INITIAL_PAGE);
  const prevPageSizeRef = useRef(25);
  const [isActionProcessed, setActionProcessed] = useState(false);

  const [dateRange, setDateRange] = useState(null);
  const [currentLegId, setCurrentLegId] = useState(null);

  const initState = {
    legCharge: {
      id: '',
      category: '',
      categoryDescription: '',
      name: '',
      amount: '',
      status: 'NEW',
    },
    remittanceModel: {
      paymentAmount: '',
      paymentNumber: '',
      paymentDate: '',
      paymentMode: '',
      transactionType: 'BILL'
    },
    dialogMessage: {
      type: '',
      title: '',
      description: '',
    }
  };

  const [legCharge, setLegCharge] = useState(initState.legCharge);
  const [remittanceModel, setRemittanceModal] = useState(initState.remittanceModel);
  const [dialogMessage, setDialogMessage] = useState(initState.dialogMessage);
  const [lastFivePayments, setLastFivePayments] = useState([]);

  useEffect(() => {
    //Cleanup function to reset state when component unmounts
    if (prevPageRef.current !== page || prevPageSizeRef.current !== pageSize || isActionProcessed) {
      prevPageRef.current = page;
      prevPageSizeRef.current = pageSize;
      executeSearch(searchParameters);
      setActionProcessed(false);
    } else {
      return () => {
        dispatch(BillPayAction.resetState('RESET_BILL_STATE'));
      };
    }
  }, [page, pageSize, isActionProcessed, transportationMode]);

  const changeTab = (tabIndex) => {
    const status = BILL_STATUS_TABS[tabIndex];
    setTabIndex(tabIndex);
    setBillStatus(status);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
    setPage(0);
  }
  /* Utils */
  const notify = (type, title, message) => {
    const notify = {
      type: type,
      title: title,
      description: message || 'No bill selected. Please select at least one bill to continue.'
    };
    setDialogMessage(notify);
    setNotificationDialog(true);
  };

  const countByPaymentStatus = (countsByStatus) => {
    const result = Object.entries(countsByStatus).map(item => ({ 'status': item[0], 'count': item[1] }));
    return result;
  };

  const paymentBreakdownPieChart = (bills) => {
    if (bills && bills.length > 0) {
      const billAmountByStatus = bills.reduce((acc, item) => {
        const key = item.status;
        if (!acc[key]) {
          acc[key] = [];
        }
        acc[key].push(item.billAmount);
        return acc;
      }, {});
      const result = Object.keys(billAmountByStatus).map(key => {
        const sum = billAmountByStatus[key].reduce((acc, amt) => { return (acc + amt); }, 0);
        return { id: key, label: key, count: billAmountByStatus[key].length, value: sum };
      });
      return result;
    } else {
      return [];
    }
  };

  /* SEARCH BILLS */
  const handleSearchFieldChange = (evt, fieldName) => {
    const searchParams = searchParameters;
    const name = fieldName;
    const param = {};
    if (evt) {
      if (fieldName === 'date-range') {
        if (evt.length === 2) {
          const start = evt[0].toISOString().substring(0, 10);
          const end = evt[1].toISOString().substring(0, 10);
          setDateRange(evt);
          param['startDate'] = start;
          param['endDate'] = end;
        } else {
          alert('Invalid Date');
        }
      } else {
        const value = fieldName === 'driver' ? `${evt.value}:${evt.additionalValue}` : evt.target.value;
        param[`${name}`] = value.trim();
      }
      setSearchParameters(Object.assign(searchParams, param));
    } else {
      if (fieldName === 'date-range') {
        setDateRange(evt);
      }
      clearSearchField(evt, fieldName);
      executeSearch(searchParameters); // This is important
    }
  };

  // Clear Search Fields - No auto search.
  const clearSearchField = (evt, fieldName) => {
    const params = searchParameters;
    if (params[fieldName]) {
      delete params[fieldName];
      // We need to clear this filtered searchOption from the searchParameters and input box.
      Array.from(document.querySelectorAll('input')).forEach(input => {
        if (input.name === fieldName) //true
          input.value = null;
      });
      setSearchParameters(params);
    }
  };

  /* Execute Search and also save state of the search variables */
  const executeSearch = (searchParameters) => {
    const isOTR = transportationMode === 'OTR';
    if (searchParameters && Object.entries(searchParameters).length > 0) {
      const params = {
        searchParam: Object.entries(searchParameters).map(([k, v]) => ({ 'label': k, 'value': v }))
      };
      const driver = params.searchParam.find(item => item.label === 'driver');
      if (driver) {
        dispatch(BillPayAction.findBills(driver.value, params, isOTR, page, pageSize));
        // API to get last 5 payments
        const paymentService = isOTR ? PaymentService : PaymentService; // does not matter for last payments.
        paymentService.getLastFivePayments(driver.value).then((res) => {
          const payments = res && res.data ? res.data.data : [];
          const barChartData = payments.map(item => ({
            'PaymentDate': item.paymentDate,
            'Amount': Number(item.amountPaid)
          }));
          setLastFivePayments(barChartData);
        });
        setAdvanceSearchDialog(false);
        setSearchEnable(true);
      } else {
        notify('ERROR', 'Missing Driver', 'Please select a driver to search the bills.');
      }
    } else {
      setAdvanceSearchDialog(false);
      setSearchEnable(false);
      dispatch(BillPayAction.resetState('RESET_BILL_STATE'));
    }
  };

  /* Create Search Chip */
  const createSearchChip = () => {
    const kvpair = Object.entries(searchParameters).map(([k, v]) => ({ 'key': k, 'value': v }));
    const chips = kvpair.map(item => {
      return <Chip key={item.key}
        label={item.value}
        onDelete={(evt) => deleteSearchChip(evt, item.key)}
        color='secondary'
        size='small'
        style={{ marginRight: 5 }}
      />;
    });
    return chips;
  };

  const deleteSearchChip = (evt, key) => {
    clearSearchField(evt, key);
    // Execute search on remaining search items if any.
    executeSearch(searchParameters);
  };

  const toggleMainMenu = (evt) => {
    const target = evt ? evt.currentTarget : null;
    setAnchorMainMenu(target);
  };
  /* DRIVER FUNCTIONS */
  const viewDriverReport = () => {
    if (selectedRows.length === 0) {
      notify('INFO', 'View Report');
    } else {
      const isOTR = transportationMode === 'OTR';
      const paymentService = isOTR ? OTRPaymentService : PaymentService;
      const billIds = selectedRows.map(bill => bill.id);
      paymentService.getBillReport(billIds);
    }
  };

  /* PROCESS DRIVER PAYMENT */
  const processDriverPayment = () => {
    let isPaymentAmountInvalid = false;
    let isPaymentAmountNegative = false;
    if (selectedRows.length === 0) {
      notify('INFO', 'Process Driver Payment');
    } else {
      let totalAmount = 0;
      selectedRows.forEach(bill => {
        const legCharges = AggregateLegCharges(bill.legCharges);
        const driverRate = bill.driverRate;
        const totalPayment = driverRate + legCharges;
        const balance = totalPayment - bill.amountPaid;

        if (bill.customAmount > balance) {
          isPaymentAmountInvalid = true;
        } else if (bill.customAmount < 0) {
          isPaymentAmountNegative = true;
        }
        if (isPaymentAmountInvalid || isPaymentAmountNegative) {
          const message = isPaymentAmountInvalid ?
            `Payment amount for bill ${bill.id} more than balance amount. Cannot process the payment.` :
            `Payment amount for bill ${bill.id} is negative. Cannot process the payment.`;
          notify('ERROR', 'View Report', message);
        } else {
          totalAmount += bill.customAmount;
        }
      });
      if (!isPaymentAmountInvalid && !isPaymentAmountNegative) { // Extra level of checking
        remittanceModel.paymentAmount = totalAmount;
        remittanceModel.paymentDate = new Date().toISOString().split('T')[0];
        remittanceModel.transactionType = 'BILL';
        setRemittanceModal(remittanceModel);
        setProcessPayment(true); //This is to display the check form.
        setRemittancePaymentDialog(true);
      }
    }
  };

  const submitPayment = (remittanceModel) => {
    const bills = []; //bills to process
    selectedRows.forEach(row => {
      const billItem = {
        'billId': row.id,
        'legId': row.legId,
        'billAmount': row.customAmount
      };
      bills.push(billItem);
    });

    const paymentData = {
      remittanceModel,
      bills
    };
    const isOTR = transportationMode === 'OTR';
    dispatch(BillPayAction.processPayment(paymentData, isOTR));
  };

  const revertDriverPayment = () => {
    const isOTR = transportationMode === 'OTR';
    if (selectedRows.length === 0) {
      notify('INFO', 'Process Unpay');
    } else {
      const billIds = selectedRows.map(bill => bill.id);
      dispatch(BillPayAction.revertDriverPayment(billIds, isOTR));
    }
  }

  /* Menu Option Dialogs */
  const processOrderDetail = (orderId) => {
    if (isOrderDetailDialogOpen) {
      setOrderDetailDialog(false);
    } else {
      const isOTR = transportationMode === 'OTR';
      if (isOTR) {
        dispatch(OTROrderAction.getOTROrderById(orderId));
      } else {
        dispatch(OrderAction.getOrderById(orderId));
      }
      setOrderDetailDialog(true);
    }
  };

  const processOrderLeg = (legId) => {
    if (isLegDetailDialogOpen) {
      setLegDetailDialog(false);
    } else {
      const isOTR = transportationMode === 'OTR';
      if (isOTR) {
        dispatch(OTROrderAction.getOrderLegById(legId));
      } else {
        dispatch(OrderAction.getOrderLegById(legId));
      }
      setLegDetailDialog(true);
    }
  };

  const toggleDriverRateDialog = (bill) => {
    if (isDriverRateDialogOpen) {
      setDriverRateDialog(false);
    } else {
      setSelectedBill(bill);
      setDriverRateDialog(true);
    }
  };

  const handleDriverRateChange = (evt) => {
    const bill = selectedBill;
    bill.driverRate = evt.target.value;
    setSelectedBill(bill);
  }

  const updateDriverBaseRate = () => {
    const driver = {};
    const legId = selectedBill.legId;
    driver.driverRate = String(selectedBill.driverRate);
    const legService = transportationMode === 'OTR' ? OTRLegService : LegService;

    legService.updateLegRate(legId, driver).then(() => {
      executeSearch(searchParameters);
    });
  };

  /* Leg Charge */
  const toggleLegChargeDialog = (bill) => {
    if (isLegChargeDialogOpen) {
      setLegChargeDialog(false);
    } else {
      setLegCharges(bill.legCharges);
      setLegChargeDialog(true);
      setCurrentLegId(bill.legId);
    }
  };

  const saveLegCharge = (legCharge) => {
    const legId = currentLegId;
    // Select the appropriate service based on OTR status
    const legChargeService = transportationMode === 'OTR' ? OTRLegService : LegService;
    legChargeService.saveLegCharges(legId, legCharge).then(res => {
      var data = res && res.data;
      if (data && data.legCharges) {
        setLegCharges(data.legCharges);
      }
      executeSearch(searchParameters);
    });
  };

  const editLegCharge = (legCharge) => {
    setLegCharge(legCharge);
    setLegChargeFormAction('Update');
  };

  const updateLegCharge = (legCharge) => {
    const legId = currentLegId;
    // Select the appropriate service based on OTR status
    const legChargeService = transportationMode === 'OTR' ? OTRLegService : LegService;
    legChargeService.updateLegCharges(legId, legCharge).then(res => {
      var data = res && res.data;
      if (data && data.legCharges) {
        setLegCharges(data.legCharges);
      }
      executeSearch(searchParameters);
    });
  };

  const deleteLegCharge = (legCharge) => {
    const legId = currentLegId;
    // Select the appropriate service based on OTR status
    const legChargeService = transportationMode === 'OTR' ? OTRLegService : LegService;
    legChargeService.deleteLegCharge(legId, legCharge.id).then((res) => {
      var data = res && res.data;
      if (data && data.legCharges) {
        setLegCharges(data.legCharges);
      }
      executeSearch(searchParameters);
    });
  };

  const processViewRemittance = (bill) => {
    if (isRemittancePaymentDialogOpen) {
      setRemittancePaymentDialog(false);
      setProcessPayment(false);
    } else {
      const isOTR = transportationMode === 'OTR';
      getRemittanceInformation('bill', bill.id, isOTR).then(res => {
        setRemittanceData(res.data);
        setProcessPayment(false); // We are not processing any payment here. Only view mode.
        setRemittancePaymentDialog(true);
      })
    }
  }

  const processFileUpload = (bill) => {
    if (isFileUploadDialogOpen) {
      setFileUploadDialog(false);
    } else {
      const { orderId } = bill;
      getFilesByOrderId(orderId, transportationMode === 'OTR')
        .then((res) => {
          if (res.status === 200 && res.data) {
            // res.data
            fileModalChildRef.current.onInit(res.data);
          }
        })
        .catch((e) => {
          // pass error
          fileModalChildRef.current.onInit(null, e);
        });
      setFileUploadDialog(true);
    }
  };

  const toggleAdvanceSearchDialog = () => {
    setAdvanceSearchDialog(!isAdvanceSearchDialogOpen);
  };

  const getDriverLabel = (driver) => {
    const primaryText = driver.fullName;
    const secondaryText = driver.phone;
    const reactSelectObj = {
      label: <Box>
        <Typography variant='body1' fontWeight={600}>{primaryText}</Typography>
        <Typography variant='caption'>{secondaryText}</Typography>
      </Box>,
      value: primaryText,
      additionalValue: secondaryText,
    };
    return reactSelectObj;
  };

  const closeActionResultDialog = (flag) => {
    dispatch(BillPayAction.resetState('RESET_TOAST_STATE'));
    setActionProcessed(true);
  };

  const { drivers, bills, activeOrder, activeLeg, totalCounts, toast, isProcessing } = props;
  const statusCounts = countByPaymentStatus(totalCounts);
  const totalSearchCount = totalCounts ? Object.entries(totalCounts).reduce((acc, itm) => {
    return acc + itm[1]
  }, 0) : 0;
  const billsByStatus = bills.filter(d => { return d.status === billStatus; });
  const paymentBreakdownData = paymentBreakdownPieChart(bills);

  let content = null;
  if (toast && toast.action && toast.message) {
    content = toast.message.map((msg, idx) =>
      <React.Fragment key={idx}>
        <Typography variant='h6'>{msg.includes('SUCCESS') ?
          <CheckCircleOutlineOutlined style={{ color: 'green', marginBottom: '-8px' }} /> :
          <CancelOutlined style={{ color: 'red', marginBottom: '-8px' }} />}&nbsp;&nbsp;{msg}
        </Typography>
        <br />
      </React.Fragment>
    );
  }
  return (
    <Page title='Driver Settlement'>
      <Box display={'flex'} justifyContent={'space-between'}>
        <PageHeader
          title='Driver Settlement'
          subTitle='Manage your driver settlement.'
        />
        <Searchbar
          searchType='ADVANCED'
          isAdvanceSearchDialogOpen={isAdvanceSearchDialogOpen}
          searchParameters={searchParameters}
          fnSearchMenuHandler={toggleAdvanceSearchDialog}
        >
          <Grid container spacing={2}>
            {SEARCH_FIELDS.map(field => {
              if (field.type === 'datalist') {
                return (
                  <Grid size={{ xs: 12, sm: 6}} key={field.name}>
                    <CustomSelectField
                      type='DRIVER'
                      id='drivers'
                      label='Driver Name'
                      name={field.name}
                      data={drivers.map(b => getDriverLabel(b))}
                      onChange={selected => handleSearchFieldChange(selected, field.name)}
                    />
                  </Grid>)
              } else if (field.type === 'date-range') {
                return (
                  <Grid size={{ xs: 6, sm: 6 }} key={field.name}>
                    <DateRangePicker
                      placeholder='Enter Date Range'
                      name='date-range'
                      format='MMM dd, yyyy'
                      value={dateRange}
                      showWeekNumbers
                      onChange={evt => handleSearchFieldChange(evt, 'date-range')}
                    />
                  </Grid>
                )
              } else {
                return (
                  <Grid size={{ xs: 6, sm: 4 }} key={field.name}>
                    <TextField
                      key={field.name}
                      label={field.label}
                      margin='none'
                      variant='outlined'
                      name={field.name}
                      type={field.type}
                      fullWidth={true}
                      size='small'
                      onChange={evt => handleSearchFieldChange(evt, field.name)}
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        endAdornment: (<IconButton size='small' name={field.name} onClick={(evt) => clearSearchField(evt, field.name)}>
                          <CloseOutlined fontSize='small' />
                        </IconButton>
                        )
                      }}
                    />
                  </Grid>
                )
              }
            })
            }
          </Grid>
          <Box
            display='flex'
            justifyContent='flex-end'
            p={2}
          >
            <Button
              variant='contained'
              color='primary'
              onClick={() => executeSearch(searchParameters)}
            >
              Search
            </Button>
          </Box>
        </Searchbar>
        <Notificationbar />
      </Box>
      <Box
        m='20px 0 0 0'
        height='75vh'
      >
        {isSearchEnabled ?
          <Box style={{ margin: '10px 0' }} textAlign={'center'}>
            <Box flex={1}>
              {createSearchChip()}
            </Box>
            <Typography variant='caption'
              style={{
                letterSpacing: 1,
                color: colors.neutral[500],
                textTransform: 'uppercase',
                marginTop: 0.5,
                fontWeight: 500,
              }}
            >
              {`${totalSearchCount} records found`}
            </Typography>
          </Box> :
          <Box sx={{ margin: '10px 0' }} textAlign={'center'}>
            <Typography variant='body1' style={{ letterSpacing: 1, textTransform: 'uppercase' }}>Select driver using the search box above to search the payments.</Typography>
          </Box>
        }
        <Box
          display={'flex'}
          mb={1}
        >
          {tenantBusinessModel === 'ALL' &&
            <Tabs
              value={transportationMode}
              onChange={(evt, value) => setTransportationMode(value)}
              textColor={colors.base.white}
              indicatorColor='primary'
              sx={{
                background: colors.neutral[100],
                borderRadius: '4px',
                padding: '4px',
                height: 6,
                gap: '4px',

              }}
            >
              {['INTERMODAL', 'OTR'].map((mode, idx) => (
                <Tab
                  key={`${idx}-${mode}`}
                  value={mode}
                  label={mode === 'INTERMODAL' ? 'Intermodal' : 'OTR'}
                  sx={{
                    minHeight: '40px',
                    padding: '6px 16px',
                    borderRadius: '4px',
                    fontWeight: 500,
                    backgroundColor:
                      transportationMode === mode ? colors.base.white : 'transparent',
                    borderBottom: '1px solid',
                    borderBottomColor:
                      transportationMode === mode ? colors.base.white : 'transparent',
                    '&:hover': {
                      backgroundColor:
                        transportationMode === mode
                          ? colors.primary.dark
                          : colors.neutral[200],
                    },
                  }}
                />
              ))
              };
            </Tabs>
          }
        </Box>
        {isProcessing && <CircularProgress style={{ position: 'absolute', top: '50%', marginLeft: '50%' }} />}
        <Grid container spacing={1}>
          <Grid size={{ xs: 12, sm: 9, md: 9 }}>
            <Box
              sx={{
                display: 'flex',
                borderRadius: '6px 6px 0px 0px',
                py: 1,
                px: 1,
                justifyContent: 'space-between',
                background: colors.blue[50]
              }}
            >
              <CTTabs
                labels={BILL_STATUS_TABS}
                tabIndex={tabIndex}
                counts={statusCounts}
                exportButtonEnabled={true}
                fnOnTabChangeHandler={(tabIndex) => changeTab(tabIndex)}
              />
              {selectedRows.length > 0 &&
                <Fade in={selectedRows.length > 0} timeout={300} unmountOnExit>
                  <Box display={'flex'} justifyContent={'space-between'}>
                    <Typography variant='body1' sx={{
                      margin: 'auto 5px',
                      background: colors.neutral[400],
                      padding: .5,
                      color: colors.base.white,
                      borderRadius: 1
                    }}
                    >
                      {selectedRows.length} Selected
                    </Typography>
                    <Typography variant='body1' sx={{
                      margin: 'auto 5px',
                      background: colors.neutral[400],
                      padding: .5,
                      color: colors.base.white,
                      borderRadius: 1
                    }}
                    >
                      {formatCurrency(selectedRows.reduce((acc, item) => { return (acc + item.billAmount); }, 0))}
                    </Typography>
                    <IconButton
                      aria-label='settings'
                      onClick={evt => toggleMainMenu(evt)}
                      size='small'
                      sx={{
                        margin: 'auto',
                        bgcolor: colors.primary.light,
                        color: colors.base.white,
                        '&:hover': {
                          bgcolor: colors.primary.main,
                        }
                      }}
                    >
                      <MenuOutlined
                        color={colors.primary.light}
                      />
                    </IconButton>
                  </Box>
                </Fade>
              }
              <Menu
                id='long-menu'
                anchorEl={anchorMainMenu}
                open={Boolean(anchorMainMenu)}
                keepMounted
                onClose={() => toggleMainMenu(null)}
              >
                <Typography variant='body2'
                  sx={{ bgcolor: colors.neutral[300], fontWeight: 500, padding: 1, textAlign: 'center' }}>
                  General
                </Typography>
                <MenuItem onClick={() => viewDriverReport()}>
                  <FTIcons.PreviewIcon fill={colors.primary.light} /> &nbsp;&nbsp;View Driver Pay
                </MenuItem>
                <Divider />
                <MenuItem disabled={tabIndex !== 0 || tabIndex == 3} onClick={() => processDriverPayment()}>
                  <FTIcons.LightningIcon fill={colors.primary.light} />&nbsp;&nbsp;Process Payment
                </MenuItem>
                <Divider />
                <MenuItem disabled={tabIndex !== 0} onClick={() => revertDriverPayment()}>
                  <FTIcons.CogIcon fill={colors.primary.light} />&nbsp;&nbsp;Revert Payment
                </MenuItem>
              </Menu>
            </Box>
            <BillPayTable
              bills={billsByStatus}
              page={page}
              pageSize={pageSize}
              rowCount={totalCounts[billStatus]}
              fnViewOrderHandler={orderId => processOrderDetail(orderId)}
              fnViewLegHandler={legId => processOrderLeg(legId)}
              fnDriverRateHandler={bill => toggleDriverRateDialog(bill)}
              fnLegChargeHandler={bill => toggleLegChargeDialog(bill)}
              fnViewRemittanceHandler={bill => processViewRemittance(bill)}
              fnFileUploadHandler={processFileUpload}
              fnOnRowSelection={rows => setSelectedRows(rows)}
              fnOnPageChange={newPage => setPage(newPage)}
              fnOnPageSizeChange={handlePageSizeChange}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3, md: 3 }}>
            <Grid container spacing={1}>
              <Grid size={{ xs: 12 }}>
                <ChartContainer
                  title='Driver Pay Breakdown'
                  height='360x'
                  width='370px'
                >
                  <Box sx={{ width: 'auto', height: 200 }}>
                    <PieChart
                      data={paymentBreakdownData || []}
                      customColor={true}
                    />
                  </Box>
                  {paymentBreakdownData && paymentBreakdownData.map(item => (
                    <Grid container spacing={1} key={item.label}>
                      <Grid size={{ xs: 6, sm: 6, md: 6 }}>
                        <Typography variant='body1' sx={{ marginLeft: 1 }}>
                          <span style={{
                            border: `3px solid ${PIE_CHART_COLORS[item.label]}`,
                            height: '12px',
                            display: 'inline-block',
                            margin: '0px 5px',
                          }}></span>
                          {item.label}
                        </Typography>
                      </Grid>
                      <Grid size={{ xs: 3, sm: 3, md: 3 }}>
                        <Typography variant='body1'>{item.count}</Typography>
                      </Grid>
                      <Grid size={{ xs: 3, sm: 3, md: 3 }}>
                        <Typography variant='body1'>{formatCurrency(item.value, 'en-US', 'compact')}</Typography>
                      </Grid>
                    </Grid>
                  ))}
                </ChartContainer>
              </Grid>
              <Grid size={{ xs: 12 }}>
                <ChartContainer
                  title='Last 5 Payments'
                  height='360px'
                  width='370px'
                >
                  <Box sx={{ height: 260 }}>
                    <BarChart
                      data={lastFivePayments || []}
                      keys={['Amount']}
                      indexKey={'PaymentDate'}
                      groupMode={'stacked'}
                      layout={'vertical'}
                      margin={{top: 10, right: 40, bottom: 30, left: 40}}
                      valueFormat={true}
                      // valueScale={{type: 'symlog'}}
                    />
                  </Box>
                </ChartContainer>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {/* ORDER DETAIL DIALOG */}
      {activeOrder && activeOrder.legs &&
        <ContentDrawer
          open={isOrderDetailDialogOpen}
          title='Load Detail'
          handleClose={() => setOrderDetailDialog(false)}
        >
          {transportationMode === 'OTR' ?
            <LoadDetail
              order={activeOrder}
              transportationMode={'OTR'}
            /> :
            <LoadDetail
              order={activeOrder}
              transportationMode={'INTERMODAL'}
            />
          }
        </ContentDrawer>
      }
      {/* ORDER LEG DIALOG */}
      {activeLeg && activeLeg.id &&
        <ContentDrawer
          open={isLegDetailDialogOpen}
          title='Leg Detail'
          handleClose={() => setLegDetailDialog(false)}
        >
          <OrderLeg leg={activeLeg} />
        </ContentDrawer>
      }
      {/* DRIVER RATE */}
      {selectedBill &&
        <DataDialog
          open={isDriverRateDialogOpen}
          title='Driver Rate'
          width={'sm'}
          onCloseHandler={() => setDriverRateDialog(false)}
        >
          <Box display={'flex'} justifyContent={'space-between'}>
            <InputField
              type='number'
              label='Enter Driver Rate'
              margin='dense'
              onChange={evt => handleDriverRateChange(evt)}
              value={selectedBill.driverRate}
              isFullWidth={true}
              valid />
            <Box>
              <IconButton
                aria-label='edit'
                color='primary'
                onClick={updateDriverBaseRate}
                size="large">
                <CheckCircleOutlined fontSize='medium' />
              </IconButton>
              <IconButton
                aria-label='cancel'
                style={{ color: 'red' }}
                onClick={() => setDriverRateDialog(false)}
                size="large">
                <CancelOutlined fontSize='medium' />
              </IconButton>
            </Box>
          </Box>
        </DataDialog>
      }
      {/* LEG CHARGES */}
      <DataDialog
        open={isLegChargeDialogOpen}
        title={'Driver Charges'}
        width={'md'}
        isProcessing={isProcessing}
        toast={toast}
        onCloseHandler={() => setLegChargeDialog(false)}
      >
        <LegCharge
          action={legChargeFormAction}
          legCharge={legCharge}
          legChargeList={legCharges}
          fnOnSaveHandler={saveLegCharge}
          fnOnEditHandler={editLegCharge}
          fnOnUpdateHandler={updateLegCharge}
          fnOnDeleteHandler={deleteLegCharge}
        />
      </DataDialog>
      {/* VIEW PAYMENT */}
      <ContentDrawer
        open={isRemittancePaymentDialogOpen}
        title={'Make Payment'}
        isProcessing={isProcessing}
        toast={toast}
        handleClose={() => setRemittancePaymentDialog(false)}
      >
        <Remittance
          remittanceModel={remittanceModel}
          remittanceData={remittanceData}
          isProcessPayment={isProcessPayment}
          fnOnSubmitPaymentHandler={submitPayment}
        />
      </ContentDrawer>
      {/* FILE UPLOAD */}
      <DataDialog
        open={isFileUploadDialogOpen}
        title={'Upload Documents'}
        width={'md'}
        onCloseHandler={() => setFileUploadDialog(false)}
      >
        <FilesModal
          ref={fileModalChildRef}
          errorData={''}
          messageData={''}
          filesData={[]}
        />
      </DataDialog>
      {/* NOTIFICATION DIALOG */}
      <NotificationDialog
        open={isNotificationDialogOpen}
        title={<Box display={'flex'} alignItems={'center'}>
          {dialogMessage && dialogMessage.type === 'INFO' ? <InfoOutlined color='primary' /> : <WarningOutlined color='error' />}
          <Typography variant='h5' style={{ marginLeft: 8 }}>{dialogMessage.title} </Typography>
        </Box>}
        handleClose={() => setNotificationDialog(false)}
      >
        <Typography variant='subtitle2'>
          {dialogMessage.description}
        </Typography>
      </NotificationDialog>
      {/* ACTION UPDATES */}
      <DataDialog
        open={content !== null}
        title='Process Driver Payment'
        width={'sm'}
        onCloseHandler={() => closeActionResultDialog(false)}
      >
        {content}
      </DataDialog>
    </Page>
  );
};

function mapStatesToProps(state) {
  const { drivers } = state.driverReducer;
  let { orders, order, activeLeg } = state.orderReducer;
  const otrOrder = state.otrOrderReducer.order;

  const { bills, totalCounts, toast, isProcessing } = state.billReducer;
  const { tenant, user } = state.tenantReducer;

  if (otrOrder && otrOrder.id) { //OTR Mode
    orders = state.otrOrderReducer.orders;
    order = otrOrder;
    activeLeg = state.otrOrderReducer.activeLeg;
  }
  return {
    activeOrder: order,
    activeLeg,
    orders,
    drivers,
    bills,
    toast,
    tenant,
    user,
    totalCounts,
    isProcessing,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Object.assign({}, OrderAction, OTROrderAction, BillPayAction, DriverAction), dispatch);
}

export default connect(mapStatesToProps, mapDispatchToProps)(BillManager);